const t = () => {
  var e;
  if (typeof window > "u") return;
  if ((e = navigator.userAgentData) != null && e.platform)
    return navigator.userAgentData.platform;
  const n = navigator.userAgent.toLowerCase();
  if (n.includes("mac")) return "macOS";
  if (n.includes("win")) return "Windows";
  if (n.includes("linux")) return "Linux";
};
export {
  t as getOS
};
